/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_No_Exercises_FoundInputs */

const fr_leaderboard_no_exercises_found = /** @type {(inputs: Leaderboard_No_Exercises_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun exercice avec des records personnels trouvé.`)
};

/**

* @param {Leaderboard_No_Exercises_FoundInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_no_exercises_found = /** @type {((inputs?: Leaderboard_No_Exercises_FoundInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_No_Exercises_FoundInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_no_exercises_found(inputs)
});